/**
 * Labstep
 *
 * @module components/Permission/Action/Revoke
 * @desc Revoke Permission
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { PermissionActionRevokeProps } from './types';

export const PermissionActionRevoke: React.FC<
  PermissionActionRevokeProps
> = ({ permission }) => (
  <EntityActionDelete
    entity={permission}
    actionComponentProps={{ type: 'icon', icon: 'times' }}
  />
);
